export const FETCH_AUDIENCES = "FETCH_AUDIENCES";

export const INSERT_AUDIENCE = "INSERT_AUDIENCE";

export const DELETE_AUDIENCE = "DELETE_AUDIENCE";

export const EDIT_AUDIENCE_INFO = "EDIT_AUDIENCE_INFO";

